import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, bootstrapped } = useAuth();
  const location = useLocation();

  if (!bootstrapped) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-hh-bg">
        <div className="text-hh-ink2 text-sm tracking-widest uppercase animate-pulse">Loading</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (role && user.role !== role) {
    // Author trying to hit admin or vice versa
    return <Navigate to={user.role === "admin" ? "/admin" : "/"} replace />;
  }
  return children;
}
